import { AndSendLoader } from './andsend-icons/andsend-loader';

export const LoaderView: React.FC = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <AndSendLoader variation="color" className="h-28" />
        </div>
    );
};
